import type {
	getUserProfileInput,
	updateUserInfoInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetUserProfile: getUserProfileInput;
	useUpdateProfile: updateUserInfoInput;
}

const PROFILE_SERVICE_KEYS = createReactQueryKeys<Keys>("profile", [
	"useGetUserProfile",
	"useUpdateProfile",
]);

export { PROFILE_SERVICE_KEYS };
